<template>
  <fragment>
    <g
      id="Wrinkles_A-5-1-10"
      v-if="data.value === 'type-10' && data.position === 'b'"
    >
      <g>
        <g>
          <g>
            <g class="cls-3">
              <path
                :fill="data.color"
                d="m180.14,191.86c4.98,7.54,12.82,7.98,20.4,4.14.52-.33,1.07.43.58.82-7.34,5.74-18,4.6-21.87-4.51-.24-.57.58-.99.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m171.64,208.64c.68.38,1.36.85,1.89,1.52,1.38,1.81,1.2,4.22,2.83,5.82,1.96,2.17,4.61,2.95,7.31,4.11,6.26,2.44,7.63,10.22,6.54,16.11-.11.62-1.05.51-.99-.13.05-18.85-10.38-11.1-15.4-21.1-.74-2.05-.65-4.26-2.7-5.47-.52-.34-.03-1.17.52-.85h0Z"
              />
            </g>
          </g>
          <g>
            <g class="cls-2">
              <path
                :fill="data.color"
                d="m139.89,191.86c-4.98,7.54-12.82,7.98-20.4,4.14-.52-.33-1.07.43-.58.82,7.34,5.74,18,4.6,21.87-4.51.24-.57-.58-.99-.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m148.39,208.64c-.68.38-1.36.85-1.89,1.52-1.38,1.81-1.2,4.22-2.83,5.82-1.96,2.17-4.61,2.95-7.31,4.11-6.26,2.44-7.63,10.22-6.54,16.11.11.62,1.05.51.99-.13-.05-18.85,10.38-11.1,15.4-21.1.74-2.05.65-4.26,2.7-5.47.52-.34.03-1.17-.52-.85h0Z"
              />
            </g>
          </g>
        </g>
        <path
          :fill="data.color"
          d="m170.32,248.86c-5.5,5.29-15.39,5.65-20.66-.16-.41-.46.24-1.11.71-.71,5.64,4.07,13.52,3.73,19.3.1.49-.37,1.1.33.65.76h0Z"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-10"
      v-if="data.value === 'type-10' && data.position === 'm'"
    >
      <g>
        <g>
          <g>
            <g class="cls-3">
              <path
                :fill="data.color"
                d="m180.14,187.36c4.98,7.54,12.82,7.98,20.4,4.14.52-.33,1.07.43.58.82-7.34,5.74-18,4.6-21.87-4.51-.24-.57.58-.99.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m171.64,204.14c.68.38,1.36.85,1.89,1.52,1.38,1.81,1.2,4.22,2.83,5.82,1.96,2.17,4.61,2.95,7.31,4.11,6.26,2.44,7.63,10.22,6.54,16.11-.11.62-1.05.51-.99-.13.05-18.85-10.38-11.1-15.4-21.1-.74-2.05-.65-4.26-2.7-5.47-.52-.34-.03-1.17.52-.85h0Z"
              />
            </g>
          </g>
          <g>
            <g class="cls-2">
              <path
                :fill="data.color"
                d="m139.89,187.36c-4.98,7.54-12.82,7.98-20.4,4.14-.52-.33-1.07.43-.58.82,7.34,5.74,18,4.6,21.87-4.51.24-.57-.58-.99-.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m148.39,204.14c-.68.38-1.36.85-1.89,1.52-1.38,1.81-1.2,4.22-2.83,5.82-1.96,2.17-4.61,2.95-7.31,4.11-6.26,2.44-7.63,10.22-6.54,16.11.11.62,1.05.51.99-.13-.05-18.85,10.38-11.1,15.4-21.1.74-2.05.65-4.26,2.7-5.47.52-.34.03-1.17-.52-.85h0Z"
              />
            </g>
          </g>
        </g>
        <path
          :fill="data.color"
          d="m170.32,244.36c-5.5,5.29-15.39,5.65-20.66-.16-.41-.46.24-1.11.71-.71,5.64,4.07,13.52,3.73,19.3.1.49-.37,1.1.33.65.76h0Z"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-10"
      v-if="data.value === 'type-10' && data.position === 't'"
    >
      <g>
        <g>
          <g>
            <g class="cls-3">
              <path
                :fill="data.color"
                d="m180.14,182.86c4.98,7.54,12.82,7.98,20.4,4.14.52-.33,1.07.43.58.82-7.34,5.74-18,4.6-21.87-4.51-.24-.57.58-.99.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m171.64,199.64c.68.38,1.36.85,1.89,1.52,1.38,1.81,1.2,4.22,2.83,5.82,1.96,2.17,4.61,2.95,7.31,4.11,6.26,2.44,7.63,10.22,6.54,16.11-.11.62-1.05.51-.99-.13.05-18.85-10.38-11.1-15.4-21.1-.74-2.05-.65-4.26-2.7-5.47-.52-.34-.03-1.17.52-.85h0Z"
              />
            </g>
          </g>
          <g>
            <g class="cls-2">
              <path
                :fill="data.color"
                d="m139.89,182.86c-4.98,7.54-12.82,7.98-20.4,4.14-.52-.33-1.07.43-.58.82,7.34,5.74,18,4.6,21.87-4.51.24-.57-.58-.99-.89-.45h0Z"
              />
              <path
                :fill="data.color"
                d="m148.39,199.64c-.68.38-1.36.85-1.89,1.52-1.38,1.81-1.2,4.22-2.83,5.82-1.96,2.17-4.61,2.95-7.31,4.11-6.26,2.44-7.63,10.22-6.54,16.11.11.62,1.05.51.99-.13-.05-18.85,10.38-11.1,15.4-21.1.74-2.05.65-4.26,2.7-5.47.52-.34.03-1.17-.52-.85h0Z"
              />
            </g>
          </g>
        </g>
        <path
          :fill="data.color"
          d="m170.32,239.86c-5.5,5.29-15.39,5.65-20.66-.16-.41-.46.24-1.11.71-.71,5.64,4.07,13.52,3.73,19.3.1.49-.37,1.1.33.65.76h0Z"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-9"
      v-if="data.value === 'type-9' && data.position === 'b'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m179.62,187.88c4.36,6.42,13.01,8.26,20.15,6.03,1.07-.28,2.11-.7,3.17-1.12.53-.23.96.57.46.88-7.69,5.65-20.58,3.89-24.65-5.31-.26-.56.54-1,.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m184.07,212.69c2.39.89,4.61,2.06,6.78,3.38,1.65,1.16,3.44,2.17,4.49,4.07.78,2.05.42,4.04.27,6.07-.45,3.77-1.36,7.44-2.6,11.03-.21.58-1.1.32-.96-.28.59-4.73,1.44-9.81,1.29-14.47-.13-1.22-.19-1.4-1.07-2.3-2.62-2.4-5.73-4.4-8.63-6.59-.52-.3-.15-1.12.42-.91h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m140.31,187.88c-4.36,6.42-13.01,8.26-20.15,6.03-1.07-.28-2.11-.7-3.17-1.12-.53-.23-.96.57-.46.88,7.69,5.65,20.58,3.89,24.65-5.31.26-.56-.54-1-.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m135.87,212.69c-2.39.89-4.61,2.06-6.78,3.38-1.65,1.16-3.44,2.17-4.49,4.07-.78,2.05-.42,4.04-.27,6.07.45,3.77,1.36,7.44,2.6,11.03.21.58,1.1.32.96-.28-.59-4.73-1.44-9.81-1.29-14.47.13-1.22.19-1.4,1.07-2.3,2.62-2.4,5.73-4.4,8.63-6.59.52-.3.15-1.12-.42-.91h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-9"
      v-if="data.value === 'type-9' && data.position === 'm'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m179.62,183.38c4.36,6.42,13.01,8.26,20.15,6.03,1.07-.28,2.11-.7,3.17-1.12.53-.23.96.57.46.88-7.69,5.65-20.58,3.89-24.65-5.31-.26-.56.54-1,.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m184.07,208.19c2.39.89,4.61,2.06,6.78,3.38,1.65,1.16,3.44,2.17,4.49,4.07.78,2.05.42,4.04.27,6.07-.45,3.77-1.36,7.44-2.6,11.03-.21.58-1.1.32-.96-.28.59-4.73,1.44-9.81,1.29-14.47-.13-1.22-.19-1.4-1.07-2.3-2.62-2.4-5.73-4.4-8.63-6.59-.52-.3-.15-1.12.42-.91h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m140.31,183.38c-4.36,6.42-13.01,8.26-20.15,6.03-1.07-.28-2.11-.7-3.17-1.12-.53-.23-.96.57-.46.88,7.69,5.65,20.58,3.89,24.65-5.31.26-.56-.54-1-.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m135.87,208.19c-2.39.89-4.61,2.06-6.78,3.38-1.65,1.16-3.44,2.17-4.49,4.07-.78,2.05-.42,4.04-.27,6.07.45,3.77,1.36,7.44,2.6,11.03.21.58,1.1.32.96-.28-.59-4.73-1.44-9.81-1.29-14.47.13-1.22.19-1.4,1.07-2.3,2.62-2.4,5.73-4.4,8.63-6.59.52-.3.15-1.12-.42-.91h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-9"
      v-if="data.value === 'type-9' && data.position === 't'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m179.62,178.88c4.36,6.42,13.01,8.26,20.15,6.03,1.07-.28,2.11-.7,3.17-1.12.53-.23.96.57.46.88-7.69,5.65-20.58,3.89-24.65-5.31-.26-.56.54-1,.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m184.07,203.69c2.39.89,4.61,2.06,6.78,3.38,1.65,1.16,3.44,2.17,4.49,4.07.78,2.05.42,4.04.27,6.07-.45,3.77-1.36,7.44-2.6,11.03-.21.58-1.1.32-.96-.28.59-4.73,1.44-9.81,1.29-14.47-.13-1.22-.19-1.4-1.07-2.3-2.62-2.4-5.73-4.4-8.63-6.59-.52-.3-.15-1.12.42-.91h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m140.31,178.88c-4.36,6.42-13.01,8.26-20.15,6.03-1.07-.28-2.11-.7-3.17-1.12-.53-.23-.96.57-.46.88,7.69,5.65,20.58,3.89,24.65-5.31.26-.56-.54-1-.88-.48h0Z"
              />
              <path
                :fill="data.color"
                d="m135.87,203.69c-2.39.89-4.61,2.06-6.78,3.38-1.65,1.16-3.44,2.17-4.49,4.07-.78,2.05-.42,4.04-.27,6.07.45,3.77,1.36,7.44,2.6,11.03.21.58,1.1.32.96-.28-.59-4.73-1.44-9.81-1.29-14.47.13-1.22.19-1.4,1.07-2.3,2.62-2.4,5.73-4.4,8.63-6.59.52-.3.15-1.12-.42-.91h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-8"
      v-if="data.value === 'type-8' && data.position === 'b'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m205.18,215.8c-2.92,2.7-5.49,5.38-7.28,8.91-1.8,3.49-2.95,7.35-4.39,11.06-.14.45-.86.28-.78-.19,1.11-7.94,3.88-17.22,12.02-20.46.41-.19.77.4.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m176.6,190.19c2.88,2.2,5.43,4.71,8.63,6.44,0,0,3.15,1.79,3.15,1.79.4.21.15.85-.28.74-2.46-.57-4.79-1.58-6.87-3.03-2.07-1.46-3.71-3.35-5.18-5.37-.27-.35.21-.84.56-.57h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m113.49,215.8c2.92,2.7,5.49,5.38,7.28,8.91,1.8,3.49,2.95,7.35,4.39,11.06.14.45.86.28.78-.19-1.11-7.94-3.88-17.22-12.02-20.46-.41-.19-.77.4-.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m142.07,190.19c-2.88,2.2-5.43,4.71-8.63,6.44,0,0-3.15,1.79-3.15,1.79-.4.21-.15.85.28.74,2.46-.57,4.79-1.58,6.87-3.03,2.07-1.46,3.71-3.35,5.18-5.37.27-.35-.21-.84-.56-.57h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-8"
      v-if="data.value === 'type-8' && data.position === 'm'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m205.18,211.3c-2.92,2.7-5.49,5.38-7.28,8.91-1.8,3.49-2.95,7.35-4.39,11.06-.14.45-.86.28-.78-.19,1.11-7.94,3.88-17.22,12.02-20.46.41-.19.77.4.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m176.6,185.69c2.88,2.2,5.43,4.71,8.63,6.44,0,0,3.15,1.79,3.15,1.79.4.21.15.85-.28.74-2.46-.57-4.79-1.58-6.87-3.03-2.07-1.46-3.71-3.35-5.18-5.37-.27-.35.21-.84.56-.57h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m113.49,211.3c2.92,2.7,5.49,5.38,7.28,8.91,1.8,3.49,2.95,7.35,4.39,11.06.14.45.86.28.78-.19-1.11-7.94-3.88-17.22-12.02-20.46-.41-.19-.77.4-.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m142.07,185.69c-2.88,2.2-5.43,4.71-8.63,6.44,0,0-3.15,1.79-3.15,1.79-.4.21-.15.85.28.74,2.46-.57,4.79-1.58,6.87-3.03,2.07-1.46,3.71-3.35,5.18-5.37.27-.35-.21-.84-.56-.57h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-8"
      v-if="data.value === 'type-8' && data.position === 't'"
    >
      <g>
        <g>
          <g class="cls-3">
            <g>
              <path
                :fill="data.color"
                d="m205.18,206.8c-2.92,2.7-5.49,5.38-7.28,8.91-1.8,3.49-2.95,7.35-4.39,11.06-.14.45-.86.28-.78-.19,1.11-7.94,3.88-17.22,12.02-20.46.41-.19.77.4.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m176.6,181.19c2.88,2.2,5.43,4.71,8.63,6.44,0,0,3.15,1.79,3.15,1.79.4.21.15.85-.28.74-2.46-.57-4.79-1.58-6.87-3.03-2.07-1.46-3.71-3.35-5.18-5.37-.27-.35.21-.84.56-.57h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <g class="cls-2">
            <g>
              <path
                :fill="data.color"
                d="m113.49,206.8c2.92,2.7,5.49,5.38,7.28,8.91,1.8,3.49,2.95,7.35,4.39,11.06.14.45.86.28.78-.19-1.11-7.94-3.88-17.22-12.02-20.46-.41-.19-.77.4-.42.68h0Z"
              />
              <path
                :fill="data.color"
                d="m142.07,181.19c-2.88,2.2-5.43,4.71-8.63,6.44,0,0-3.15,1.79-3.15,1.79-.4.21-.15.85.28.74,2.46-.57,4.79-1.58,6.87-3.03,2.07-1.46,3.71-3.35,5.18-5.37.27-.35-.21-.84-.56-.57h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-7"
      v-if="data.value === 'type-7' && data.position === 'b'"
    >
      <g>
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-6"
      v-if="data.value === 'type-6' && data.position === 'b'"
    >
      <g>
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-5"
      v-if="data.value === 'type-5' && data.position === 'b'"
    >
      <g>
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-4"
      v-if="data.value === 'type-4' && data.position === 'b'"
    >
      <g>
        <path
          d="M187.07,217.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,217.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M187.07,217.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,217.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-3"
      v-if="data.value === 'type-3' && data.position === 'b'"
    >
      <g>
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,209.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,209.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-2"
      v-if="data.value === 'type-2' && data.position === 'b'"
    >
      <g>
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,182.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,184.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,182.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,184.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-1"
      v-if="data.value === 'type-1' && data.position === 'b'"
    >
      <g>
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,132.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,133.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-7-2"
      v-if="data.value === 'type-7' && data.position === 'm'"
    >
      <g>
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-6-2"
      v-if="data.value === 'type-6' && data.position === 'm'"
    >
      <g>
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-5-2"
      v-if="data.value === 'type-5' && data.position === 'm'"
    >
      <g>
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-4-2"
      v-if="data.value === 'type-4' && data.position === 'm'"
    >
      <g>
        <path
          d="M187.07,212.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,212.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M187.07,212.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,212.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-3-2"
      v-if="data.value === 'type-3' && data.position === 'm'"
    >
      <g>
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,204.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,204.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-2-2"
      v-if="data.value === 'type-2' && data.position === 'm'"
    >
      <g>
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,177.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,179.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,177.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,179.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-1-2"
      v-if="data.value === 'type-1' && data.position === 'm'"
    >
      <g>
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,127.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,128.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-7-3"
      v-if="data.value === 'type-7' && data.position === 't'"
    >
      <g>
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-6-3"
      v-if="data.value === 'type-6' && data.position === 't'"
    >
      <g>
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-5-3"
      v-if="data.value === 'type-5' && data.position === 't'"
    >
      <g>
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g>
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-4-3"
      v-if="data.value === 'type-4' && data.position === 't'"
    >
      <g>
        <path
          d="M187.07,207.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,207.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M187.07,207.19c4.16-1.03,9.77,4.44,5.58,5.98-1.66,.61-1.56-2.51-5.58-5.98Z"
          :fill="data.color"
        />
        <path
          d="M131.14,207.19c-4.16-1.03-9.77,4.44-5.58,5.98,1.66,.61,1.56-2.51,5.58-5.98Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-3-3"
      v-if="data.value === 'type-3' && data.position === 't'"
    >
      <g>
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M182.71,199.25s12.65,9.45,14.2,19.04c0,0-.45,5.27-2.1,7.22,0,0,4.78-4.39,4.82-8.92s-9.49-13.94-16.92-17.34Z"
          :fill="data.color"
        />
        <path
          d="M136.82,199.25s-12.65,9.45-14.2,19.04c0,0,.45,5.27,2.1,7.22,0,0-4.78-4.39-4.82-8.92-.04-4.54,9.49-13.94,16.92-17.34Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-2-3"
      v-if="data.value === 'type-2' && data.position === 't'"
    >
      <g>
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M217.38,172.61c5.93-1.81,9.05-.87,7.94,.79-.92,1.38-5.69,.19-7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M213.85,174.49c6.14,.81,9.49,3.5,7.66,4.29s-6.02-2.46-7.66-4.29Z"
          :fill="data.color"
        />
        <path
          d="M102.02,172.61c-5.93-1.81-9.05-.87-7.94,.79,.92,1.38,5.69,.19,7.94-.79Z"
          :fill="data.color"
        />
        <path
          d="M105.54,174.49c-6.14,.81-9.49,3.5-7.66,4.29s6.02-2.46,7.66-4.29Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Wrinkles_A-5-1-1-3"
      v-if="data.value === 'type-1' && data.position === 't'"
    >
      <g>
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M112.64,122.34c17.82-13.12,62.16-12.48,82.72-5.43,3.8,1.33,7.69,2.83,10.81,5.43-3.45-2.04-7.35-3.09-11.21-4.02-19.78-4.72-64.47-5.53-82.31,4.02h0Z"
          :fill="data.color"
        />
        <path
          d="M122.51,123.93c2.5-1.99,5.98-2.05,9.02-2.33,3.13-.17,6.24-.18,9.34-.15,6.2,.04,12.36,.2,18.52,.17,6.18,.03,12.34-.14,18.52-.18,3.1-.03,6.21-.02,9.34,.15,3.05,.28,6.53,.34,9.02,2.33-.97-.55-2.19-.77-3.29-.9-8.09-.29-16.16,1.14-24.26,1.36-9.31,.44-18.67,.17-27.96-.61-5-.32-9.97-1.06-14.97-.75-1.09,.13-2.33,.35-3.29,.9h0Z"
          :fill="data.color"
        />
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarWrinklesA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
